import React, { useState } from "react";
import "../../styles/table-main/main.css";
import "../../styles/sahityik-sanskritik/main.css";

const Main = () => {
    const [activeTab, setActiveTab] = useState("tabClick");

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <div id="sahityikSanskritikMain">
            <div id="tableMain">
                <div className="table-main">
                    <div className="container mt-5">
                        <div className="row rounded-1">
                            <ul className="nav nav-tabs  mt-3" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "tabClick" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("tabClick")}
                                    >
                                        Members &amp; Teams
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "tabClick1" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("tabClick1")}
                                    >
                                        Constitution
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "tabClick2" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("tabClick2")}
                                    >
                                        Events{" "}
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "tabClick3" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("tabClick3")}
                                    >
                                        Campus Notices
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "tabClick4" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("tabClick4")}
                                    >
                                        Campus &amp; College Notices
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content" id="myTabContent">
                                <div
                                    className={`tab-pane fade ${activeTab === "tabClick" ? "show active" : ""
                                        }`}
                                    id="tabClick"
                                ></div>
                                <div
                                    className={`tab-pane fade ${activeTab === "tabClick1" ? "show active" : ""
                                        }`}
                                    id="tabClick1"
                                ></div>
                                <div
                                    className={`tab-pane fade ${activeTab === "tabClick2" ? "show active" : ""
                                        }`}
                                    id="tabClick2"
                                >
                                    <div className="col-md-12 pull-left flip sm-pull-none">
                                        <div className="admin-table">
                                            {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                            <div className="table-scrollable">
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Sno</th>
                                                            <th>Title</th>
                                                            <th>Download</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>01</td>
                                                            <td>
                                                                Inclusion of Proctor in the Literary-Cultural
                                                                Council of CCS University
                                                            </td>
                                                            <td>
                                                                <a
                                                                    href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/1810_%20SSPcommittee_Prof.Beerpal.pdf"
                                                                    className="btn btn-primary btn-download"
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    Download
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`tab-pane fade ${activeTab === "tabClick3" ? "show active" : ""
                                        }`}
                                    id="tabClick3"
                                ></div>
                                <div
                                    className={`tab-pane fade ${activeTab === "tabClick4" ? "show active" : ""
                                        }`}
                                    id="tabClick4"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="table-main">
                    <div className="container mt-5 mb-5 admin-container">
                        <div className="row">
                            <div className="col-md-12 pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 className="my-heading">
                                        Sahityik Sanskritik Parishad Yearly Reports
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Sno</th>
                                                    <th>Title</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>01</td>
                                                    <td>
                                                        Sahityik Sanskritik Parishad Report Year 2023-24{" "}
                                                    </td>
                                                    <td>
                                                        <a
                                                            href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/%E0%A4%8F%E0%A4%B8%E0%A4%8F%E0%A4%B8%E0%A4%AA%E0%A5%80_Report_2023final.pdf"
                                                            className="btn btn-primary btn-download"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="gallery-main">
                    <div className="container">
                        <h1 className="my-heading mb-3">GALLERY</h1>
                        <ul>
                            <li>
                                <a
                                    data-bs-toggle="modal"
                                    href="#exampleModalToggle"
                                    role="button"
                                    className="btn-gallery"
                                >
                                    <img
                                        src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/1.jpg"
                                        alt="gallery"
                                    />
                                </a>
                                <a
                                    className="view_more_btn"
                                    data-bs-toggle="modal"
                                    href="#exampleModalToggle"
                                    role="button"
                                >
                                    View More
                                </a>
                            </li>
                        </ul>
                    </div>
                </section>
                <div className="modal-main">
                    <div
                        className="modal fade"
                        id="exampleModalToggle"
                        aria-hidden="true"
                        aria-labelledby="exampleModalToggleLabel"
                        tabIndex={-1}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div
                                    id="carouselExampleControls"
                                    className="carousel slide"
                                    data-bs-ride="carousel"
                                >
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img
                                                src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/1.jpg"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/1.jpg"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                    </div>
                                    <button
                                        className="carousel-control-prev"
                                        type="button"
                                        data-bs-target="#carouselExampleControls"
                                        data-bs-slide="prev"
                                    >
                                        <span
                                            className="carousel-control-prev-icon"
                                            aria-hidden="true"
                                        />
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button
                                        className="carousel-control-next"
                                        type="button"
                                        data-bs-target="#carouselExampleControls"
                                        data-bs-slide="next"
                                    >
                                        <span
                                            className="carousel-control-next-icon"
                                            aria-hidden="true"
                                        />
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                    <div className="close-btn-modal">
                                        <button data-bs-dismiss="modal" aria-label="Close">
                                            <i
                                                className="fa fa-times"
                                                aria-hidden="true"
                                                style={{ cursor: "pointer" }}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
